export const INITIAL_CC_COMMISSION = 20;
export const INITIAL_CCC_COMMISSION = 0;
export const INITIAL_NCC_COMMISSION = 0;
export const INITIAL_ROS_COMMISSION = 0;

export const SUGGESTED_CC_COMMISSION = 20;
export const SUGGESTED_CCC_COMMISSION = 0;
export const SUGGESTED_NCC_COMMISSION = 0;
export const SUGGESTED_ROS_COMMISSION = 5;
